import SpecialOfferContactFormEntryGenerated, { SpecialOfferContactFormEntryGeneratedEntityManager } from './generated/SpecialOfferContactFormEntry.generated';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';


export class SpecialOfferContactFormEntryEntityManager extends SpecialOfferContactFormEntryGeneratedEntityManager<SpecialOfferContactFormEntry>
{
    constructor()
    {
        super({
            createEntity: () => new SpecialOfferContactFormEntry(),
            fields: [
                { name: 'numberOfNights', type: BusinessEntityFieldType.Integer, isInput: false },
            ]
        });
    }
}


/**
 * SpecialOfferContactFormEntry
 * 
 * Read this document on how to work with TypeScript business entities: .cursor/rules/xapp-ts-business-entity-rules.mdc
 */
export class SpecialOfferContactFormEntry extends SpecialOfferContactFormEntryGenerated
{
    static _manager: SpecialOfferContactFormEntryEntityManager;
    static get manager(): SpecialOfferContactFormEntryEntityManager
    {
        if (!this._manager) this._manager = new SpecialOfferContactFormEntryEntityManager();
        return this._manager;
    }

    /** The number of nights for the booking inquiry (check_out_date - check_in_date) */
    numberOfNights: number | null = null;
}


export default SpecialOfferContactFormEntry;